export default __webpack_public_path__ + "static/media/not-available.d03bdbdf.svg";